import * as layout from '../../../components/markLayout.module.css';
import { MarkButton } from '../../../components/MarkControls';
import React from 'react';
import P from '@hero/ui-kit/typography/P';
import type { DemoDripInstance } from '../../../types';
type Props = {
    instance: DemoDripInstance;
    onFastForward: (instance: DemoDripInstance) => void;
    onReset: (instance: DemoDripInstance) => void;
    fastForwardPending: boolean;
    // True while a conflicting action on this row/profile is in flight —
    // disables the button without claiming this row's own action is running.
    fastForwardBlocked: boolean;
    resetPending: boolean;
    resetBlocked: boolean;
    error: string | null;
};

const DemoInstanceRow: React.FC<Props> = ({
    instance,
    onFastForward,
    onReset,
    fastForwardPending,
    fastForwardBlocked,
    resetPending,
    resetBlocked,
    error
}) => {
    const alreadyReset = instance.reset;
    const fastForwardDisabled = alreadyReset || fastForwardPending || fastForwardBlocked;
    const resetDisabled = alreadyReset || resetPending || resetBlocked;
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    gap: '0.6rem',
                    alignItems: 'center'
                }}
            >
                <MarkButton
                    type="button"
                    onClick={() => onFastForward(instance)}
                    disabled={fastForwardDisabled}
                    title={
                        alreadyReset
                            ? 'This instance was reset — enroll again to test it.'
                            : fastForwardBlocked
                              ? 'A reset is in progress for this profile.'
                              : undefined
                    }
                >
                    {fastForwardPending ? 'Working…' : 'Fast-forward'}
                </MarkButton>
                <MarkButton
                    type="button"
                    onClick={() => onReset(instance)}
                    disabled={resetDisabled}
                    title={
                        alreadyReset
                            ? 'Already reset.'
                            : resetBlocked
                              ? 'A fast-forward is in progress for this profile.'
                              : undefined
                    }
                >
                    {resetPending ? 'Working…' : 'Reset'}
                </MarkButton>
                <a
                    href={`/mark/contacts/${instance.profile_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Open contact
                </a>
            </div>
            {error && (
                <div
                    role="alert"
                    style={{
                        marginTop: '0.4rem'
                    }}
                    className={layout.notice}
                >
                    <P
                        noDefaultMargin
                        size="small"
                        styles={{
                            color: 'var(--mark-danger)'
                        }}
                    >
                        {error}
                    </P>
                </div>
            )}
        </>
    );
};
export default DemoInstanceRow;
